'use strict';

var App = require('app');
var AppState = require('app_state');
var Consts = require('consts');
var i18n = require('utils/i18n');
var Log = require('utils/log');
var Misc = require('utils/misc');
var Tiles = require('components/dashboard/tiles/abstract_tile');

function requestStatisticData(filter, series) {
    var def = $.Deferred();
    App.ajax({
        method: 'POST',
        url: '/api/v1/devices/statistics',
        data: JSON.stringify({
            filter: filter,
            series: _.map(series, function (item) {
                return item.value;
            }),
        }),
        success: function (resultData) {
            def.resolve({
                data: resultData,
                success: true,
            });
        },
        error: function (err) {
            def.resolve({
                success: false,
            });
        },
    });
    return def;
}

module.exports = {
    getData: function () {
        var def = $.Deferred();
        var config = this.definition.config || {};

        switch (this.definition.source) {
            case 'alarms':
                // only show alarms not yet resolved (0=not resoved, 1=resolved and not resolved, 2=resolved)
                config.filter.triggered_mode = 0;
                var self = this;
                var req = App.requestSilent('alarm-occurrences:list', config.filter, config.grouping);
                $.when(req).done(function (resp) {
                    if (!resp || !resp.items) {
                        def.resolve({
                            fetchedAt: new Date(),
                            status: Tiles.FETCH_STATUS.ERROR,
                        });
                        return;
                    }

                    if (resp.items.length === 0) {
                        def.resolve({
                            data: {
                                title: i18n.TR('Keine Alarme gefunden'),
                                text: i18n.TR('Es wurden keine Alarme gefunden.'),
                                color_class: 'box-color-info',
                            },
                            fetchedAt: new Date(),
                            status: Tiles.FETCH_STATUS.NO_RESULT,
                        });
                        return;
                    }

                    function getRow(item) {
                        function getColumn(col, attr) {
                            switch (col) {
                                case 'alarm':
                                    return attr.alarm_name;
                                case 'device':
                                    attr.modelType = 'device';
                                    attr.status = attr.device_status;
                                    attr.id = attr.device_id;
                                    attr.category = attr.device_category;
                                    attr.name = attr.device_name;
                                    return { device: attr, id: '#_name', special: true };
                                case 'time':
                                    return Misc.formatDate(attr.triggered_time);
                                case 'resolved':
                                    return attr.corrected_time == '1900-01-01T00:00:00Z'
                                        ? '-'
                                        : Misc.formatDate(attr.corrected_time);
                                case 'priority':
                                    return attr.priority;
                                default:
                                    Log.Assert(false);
                            }
                        }

                        var defaultColumns = ['alarm', 'device', 'time', 'resolved', 'priority'];
                        return _.map(self.definition.config.columns || defaultColumns, function (col) {
                            return getColumn(col, item.attributes);
                        });
                    }

                    var rows = _.map(resp.items.models, getRow);
                    var headings = {
                        alarm: i18n.TR('Alarm'),
                        device: i18n.TR('Gerät'),
                        time: i18n.TR('Zeit'),
                        resolved: i18n.TR('Behoben'),
                        priority: i18n.TR('Priorität'),
                    };
                    var data = {
                        headings: _.map(self.definition.config.columns, function (key) {
                            return headings[key];
                        }),
                        rows: rows,
                    };

                    def.resolve({
                        data: data,
                        fetchedAt: new Date(),
                        status: Tiles.FETCH_STATUS.OK,
                    });
                });
                break;

            case 'ranking':
                // ranking feature not available? -> cancel
                if (AppState.user.get('features') && !AppState.user.get('features')[Consts.Features.DeviceRanking]) {
                    def.resolve({
                        data: {
                            title: i18n.TR('SmartDetection ist nicht aktiviert'),
                            color_class: 'box-color-info',
                        },
                        fetchedAt: new Date(),
                        status: Tiles.FETCH_STATUS.NO_RESULT,
                    });
                    break;
                }
                var filterData = config.ranking || {};
                var self = this;
                function getRow(item) {
                    function getColumn(col, item) {
                        switch (col) {
                            case 'name':
                                return { device: item, id: '#_name', special: true };
                            case 'rule':
                                return i18n.TR(item.rule_name);
                            case 'priority':
                                return item.priority;
                            case 'rating':
                                return { device: item, id: '#_ranking', special: true };
                            case 'time':
                                return Misc.formatDate(item.begin_time);
                            default:
                                Log.Assert(false);
                        }
                    }

                    var defaultColumns = ['name', 'rule', 'priority', 'rating', 'time'];
                    return _.map(self.definition.config.columns || defaultColumns, function (col) {
                        return getColumn(col, item);
                    });
                }
                var rankingReq = App.request('ranking:devices', filterData);
                $.when(rankingReq).done(function (resp) {
                    if (resp === undefined || resp.attributes === undefined) {
                        def.resolve({
                            fetchedAt: new Date(),
                            status: Tiles.FETCH_STATUS.ERROR,
                        });
                        return;
                    }

                    if (resp.get('count') == 0) {
                        def.resolve({
                            data: {
                                title: i18n.TR('Keine Geräte gefunden'),
                                text: i18n.TR('Es wurden keine Geräte gefunden.'),
                                color_class: 'box-color-info',
                            },
                            fetchedAt: new Date(),
                            status: Tiles.FETCH_STATUS.NO_RESULT,
                        });
                        return;
                    }

                    var rows = [];
                    rows = _.map(resp.attributes.items, getRow);

                    var data = {
                        headings: _.map(self.definition.config.columns, function (col) {
                            return {
                                name: i18n.TR('Name'),
                                rule: i18n.TR('Regel'),
                                priority: i18n.TR('Priorität'),
                                rating: i18n.TR('Bewertung'),
                                time: i18n.TR('Startzeit'),
                            }[col];
                        }),
                        rows: rows,
                    };

                    def.resolve({
                        data: data,
                        fetchedAt: new Date(),
                        status: Tiles.FETCH_STATUS.OK,
                    });
                });
                break;
            case 'statistic':
                var requestList = _.map(config.filterList, function (filter) {
                    return requestStatisticData(filter, config.series);
                });
                $.when.apply($, requestList).done(function () {
                    var responseList = arguments;
                    var rows = [];
                    var columns = AppState.availableColumns();
                    var noData = _.reduce(
                        responseList,
                        function (allResponsesHaveFailed, resp) {
                            return allResponsesHaveFailed && !resp.success;
                        },
                        true
                    );

                    if (noData) {
                        def.resolve({
                            fetchedAt: new Date(),
                            status: Tiles.FETCH_STATUS.ERROR,
                        });
                        return def;
                    }

                    for (var rowIdx = 0; rowIdx < config.series.length; rowIdx++) {
                        var serie = config.series[rowIdx];
                        var addr = serie.value;
                        rows[rowIdx] = [serie.name];

                        var model = _.findWhere(columns, { id: addr }) || {};
                        model.type = addr.split('_')[0];
                        model.nr = addr.split('_')[1];
                        model.modelType = 'value';

                        for (var respIdx = 0; respIdx < responseList.length; respIdx++) {
                            var m = $.extend({ data: {} }, model);
                            if (serie.unit != undefined) {
                                m.unit = serie.unit;
                                m.format = serie.format;
                            }
                            if (responseList[respIdx].success) {
                                var data = responseList[respIdx].data;
                                m.data[addr] = data[addr][serie.aggregation];
                            } else {
                                rows[rowIdx].push('--');
                                continue;
                            }
                            rows[rowIdx].push({ device: m, id: '#_value', special: true });
                        }
                    }

                    def.resolve({
                        data: {
                            rows: rows,
                            headings: config.headings,
                            footer: config.footer,
                        },
                        fetchedAt: new Date(),
                        status: Tiles.FETCH_STATUS.OK,
                    });
                });
                break;
            default:
                $.getJSON(this.definition.source, { 'request-time': Date.now() }, function (data) {
                    def.resolve({
                        data: data,
                        fetchedAt: new Date(),
                        status: Tiles.FETCH_STATUS.OK,
                    });
                }).fail(function () {
                    def.resolve({
                        fetchedAt: new Date(),
                        status: Tiles.FETCH_STATUS.ERROR,
                    });
                });
                break;
        }
        return def;
    },

    template: require('components/dashboard/templates/table'),

    hasChanged: function (oldData, newData) {
        if (!oldData || !newData) {
            return false;
        }

        switch (this.definition.source) {
            case 'alarms':
                return JSON.stringify(oldData.rows[0][2]) != JSON.stringify(newData.rows[0][2]);
            case 'ranking':
                return JSON.stringify(oldData.rows[0][4]) != JSON.stringify(newData.rows[0][4]);
            default:
                return JSON.stringify(oldData) != JSON.stringify(newData);
        }
    },

    getState: function () {
        return this.acknowledged ? Tiles.STATUS.OK : Tiles.STATUS.ERROR;
    },
};
